import { memo } from "react";

const ToastInfoIcon = memo(function ToastInfoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      id="Info--Streamline-Font-Awesome"
      height="18"
      width="18"
      className="mr-2 fill-neutral-400"
      aria-hidden="true"
    >
      <desc>Info Streamline Icon: https://streamlinehq.com</desc>
      <path
        d="M6.4319999999999995 1.728c0 -1.20705 1.3066666666666666 -1.9614500000000001 2.352 -1.357925 0.48514166666666664 0.2800916666666666 0.7839999999999999 0.7977333333333334 0.7839999999999999 1.357925 0 1.20705 -1.3066666666666666 1.9614500000000001 -2.352 1.357925 -0.48514166666666664 -0.2800916666666666 -0.7839999999999999 -0.7977333333333334 -0.7839999999999999 -1.357925ZM4.864 6.4319999999999995c0 -0.5781999999999999 0.4671333333333333 -1.0453333333333332 1.0453333333333332 -1.0453333333333332H8c0.5781999999999999 0 1.0453333333333332 0.4671333333333333 1.0453333333333332 1.0453333333333332v7.317333333333334h1.0453333333333332c0.5781999999999999 0 1.0453333333333332 0.4671333333333333 1.0453333333333332 1.0453333333333332s-0.4671333333333333 1.0453333333333332 -1.0453333333333332 1.0453333333333332H5.9093333333333335c-0.5781999999999999 0 -1.0453333333333332 -0.4671333333333333 -1.0453333333333332 -1.0453333333333332s0.4671333333333333 -1.0453333333333332 1.0453333333333332 -1.0453333333333332h1.0453333333333332V7.477333333333332H5.9093333333333335c-0.5781999999999999 0 -1.0453333333333332 -0.4671333333333333 -1.0453333333333332 -1.0453333333333332Z"
        strokeWidth="0.0833"
      ></path>
    </svg>
  );
});

export default ToastInfoIcon;
